module.exports = __webpack_public_path__ + "static/Increase-shopify-conversion-rate-897d361d50ecaa299fc1a2b7cbe91d10.png";